import React, { useState, useEffect, useMemo } from 'react';
import { Button, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/system';
import { checkStartSpecialChar } from '../tabs/Constfunctions';

export const AssumptionQuestionModal = ({ column1, open, closeModal, onSubmit, defaultValue }) => {
  const initial = {
    AssumptionId: 0,
    Assumption: '',
    QuestionId: 0,
    Question: '',
    QuestionOrder: 0,
    AssumptionOrder: 0,
    AssumptionType: 'General',
    Answer: ''
  };

  useEffect(() => {
    const value = defaultValue || initial;
    setFormState(value);
  }, [open]);

  const [formState, setFormState] = useState(initial);

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const disablSaveBtn = useMemo(() => formState.Assumption === '' && formState.Question === '', [formState]);

  const items = [
    { text: 'Feature', value: 'ProgramType' },
    { text: 'Addons', value: 'AddOn' },
    { text: 'General', value: 'General' }
  ];

  return (
    <React.Fragment>
      <Dialog
        sx={{ width: '100%' }}
        open={open}
        onClose={closeModal}
        PaperProps={{
          component: 'form',
          style: {
            maxWidth: '500px'
          },
          onSubmit: (event) => {
            event.preventDefault();
            onSubmit(formState);
            closeModal();
          }
        }}
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: '100%',
              display: 'grid',
              minWidth: '400px'
            }}
          >
            <TextField
              sx={{ m: 1 }}
              id={column1 === 'assumption' ? 'assumption' : 'question'}
              label={column1 === 'assumption' ? 'Assumption' : 'Question'}
              variant="filled"
              multiline
              maxRows={3}
              name={column1 === 'assumption' ? 'Assumption' : 'Question'}
              onChange={handleChange}
              onKeyDown={checkStartSpecialChar}
              value={column1 === 'assumption' ? formState.Assumption : formState.Question}
            />

            {column1 === 'assumption' && (
              <FormControl variant="filled" sx={{ m: 1, minWidth: 260 }}>
                <InputLabel id="Assumption-type-label">Category</InputLabel>
                <Select
                  labelId="Assumption-type-label"
                  id="Assumption-type-Id"
                  name="AssumptionType"
                  value={formState.AssumptionType}
                  onChange={handleChange}
                >
                  {items.map((item, index) => {
                    return (
                      <MenuItem key={index + item.text} value={item.value}>
                        {item.text}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}

            {column1 === 'question' && (
              <TextField
                sx={{ m: 1 }}
                id="answer"
                label={'Answer'}
                variant="filled"
                multiline
                maxRows={3}
                name={'Answer'}
                onChange={handleChange}
                onKeyDown={checkStartSpecialChar}
                value={formState.Answer}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="secondary">
            Cancel
          </Button>
          <Button type="submit" color="secondary" disabled={disablSaveBtn}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
